<template>
    <div class="process-workList">
        <mc-operate-bar>
            <template slot="left">
                <mc-search-bar v-model="searchParmas" search-label="输入工单号/站点名称/工单标题" :search-submit="$_getTableList"></mc-search-bar>
            </template>
        </mc-operate-bar>
        <mc-table ref="mc-table" :table-option="tableOption" v-loading="tableOption.loading">
            <template slot="table-components">
                <el-table-column :prop="tableOption.head[0].prop" :label="tableOption.head[0].label" :width="tableOption.head[0].width"
                    v-if="tableOption.head.length>0"></el-table-column>
                <el-table-column :prop="tableOption.head[1].prop" :label="tableOption.head[1].label" :width="tableOption.head[1].width"
                    v-if="tableOption.head.length>0">
                    <template slot-scope="scope">
                        <span class="name" @click="dialog.name.methods.open(scope.row.site_name)">{{scope.row.site_name}}</span>
                    </template>
                </el-table-column>
                <el-table-column :prop="tableOption.head[2].prop" :label="tableOption.head[2].label" :width="tableOption.head[2].width"
                    v-if="tableOption.head.length>0">
                    <template slot-scope="scope">
                        <span class="name" @click="dialog.name.methods.open(scope.row.name)">{{scope.row.name}}</span>
                    </template>
                </el-table-column>
                <el-table-column :prop="tableOption.head[3].prop" :label="tableOption.head[3].label" :width="tableOption.head[3].width"
                    v-if="tableOption.head.length>0"></el-table-column>
                <el-table-column :prop="tableOption.head[4].prop" :label="tableOption.head[4].label" :width="tableOption.head[4].width"
                    v-if="tableOption.head.length>0">
                    <template slot-scope="scope">
                        <span v-if="scope.row.server_type == 1">故障处理</span>
                        <span v-else-if="scope.row.server_type == 2">配置变更</span>
                        <span v-else-if="scope.row.server_type == 3">配置更换</span>
                        <span v-else-if="scope.row.server_type == 4">健康巡检</span>
                    </template>
                </el-table-column>
                <el-table-column :prop="tableOption.head[5].prop" :label="tableOption.head[5].label" :width="tableOption.head[5].width"
                    v-if="tableOption.head.length>0">
                    <template slot-scope="scope">
                        <span v-if="scope.row.problem_type == 1">其他</span>
                        <span v-else-if="scope.row.problem_type == 2">网络</span>
                        <span v-else-if="scope.row.problem_type == 3">储存</span>
                        <span v-else-if="scope.row.problem_type == 4">服务器</span>
                        <span v-else-if="scope.row.problem_type == 5">中间件</span>
                        <span v-else-if="scope.row.problem_type == 6">数据库</span>
                        <span v-else-if="scope.row.problem_type == 7">操作系统</span>
                        <span v-else-if="scope.row.problem_type == 8">硬件故障</span>
                    </template>
                </el-table-column>
                <el-table-column :prop="tableOption.head[6].prop" :label="tableOption.head[6].label" :width="tableOption.head[6].width"
                    v-if="tableOption.head.length>0">
                    <template slot-scope="scope">
                        {{$_timeStamp(scope.row.duration)}}
                    </template>
                </el-table-column>
                <el-table-column :prop="tableOption.head[7].prop" :label="tableOption.head[7].label" :width="tableOption.head[7].width"
                    v-if="tableOption.head.length>0">
                    <template slot-scope="scope">
                        {{$_timeStamp(scope.row.idle)}}
                    </template>
                </el-table-column>
                <el-table-column :prop="tableOption.head[8].prop" :label="tableOption.head[8].label" :width="tableOption.head[8].width"
                    v-if="tableOption.head.length>0">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == 0">成功</span>
                        <span v-else-if="scope.row.status == 1">处理中</span>
                        <span v-else-if="scope.row.status == 2">升级中</span>
                    </template>
                </el-table-column>
            </template>
        </mc-table>
        <mc-pager :pager-option.sync="pager" ref="dealing-worklist-pager" @getList="$_getTableList"></mc-pager>

          <mc-dialog :dialog-option.sync="dialog.name">
            <template slot="content">
                <mc-label info>{{this.dialog.name.data.key}}</mc-label>
            </template>
        </mc-dialog>
    </div>
</template>

<script>
    export default {
        name: 'user-process-workList',
        data() {
            return {
                searchParmas: '',
                pager: {
                    page: 1,
                    per_page: 10,
                    per_pages: [10, 20, 30, 40, 50],
                    total: 0,
                },
                tableOption: {
                    loading: false,
                    index: {
                        disable: true,
                    },
                    operations: {
                        disable: true,
                        label: "操作",
                        items: [{
                            label: "查看",
                            type: "default",
                            size: 'mini',
                            click: (index, row) => {
                                this.$_goToDetails(row);
                            },
                        }, ],
                    },
                    head: [{
                            prop: "id",
                            label: "工单号",
                            width: "120",
                        },
                        {
                            prop: "site_name",
                            label: "站点名称",
                            width: "",
                        },
                        {
                            prop: "name",
                            label: "标题",
                            width: "",
                        },
                        {
                            prop: "creater_name",
                            label: "创建者",
                            width: "80",
                        },
                        {
                            prop: "problem_type",
                            label: "工单类型",
                            width: "100",
                        },
                        {
                            prop: "server_type",
                            label: "事件类型",
                            width: "100",
                        },
                        {
                            prop: "duration",
                            label: "持续时间",
                            width: "130",
                        },
                        {
                            prop: "idle",
                            label: "滞留时间",
                            width: "130",
                        },
                        {
                            prop: "status",
                            label: "工单状态",
                            width: "100",
                        },
                    ],
                    data: [],
                },
                dialog: {
                    name: {
                        visible: false,
                        title: "详情",
                        style: {
                            showConfirm: false,
                            showCancel: false,
                        },
                        methods: {
                            open: (item) => {
                                this.dialog.name.visible = true;
                                this.dialog.name.data.key = item;
                            },
                        },
                        data: {
                            key: "",
                        },
                    },
                },
            }
        },
        mounted() {
            this.$_getTableList();
        },
        methods: {
            $_getTableList: async function () {
                this.tableOption.loading = true;
                let params = {
                    page: this.pager.page,
                    per_page: this.pager.per_page,
                    query: this.searchParmas
                }
                let data = await this.$api.userProcessWorkList.getList.getProcessWorkList.call(this, params);
                if (data !== false) {
                    this.pager.total = data.total;
                    this.tableOption.data = data.data;
                }
                this.tableOption.loading = false;
            },
            $_timeStamp(time) {
                let day = parseInt(time / 60 / 24);
                let hour = parseInt(time / 60 % 24);
                let min = parseInt(time % 60);
                time = "";
                if (day > 0) {
                    time = day + "天";
                }
                if (hour > 0) {
                    time += hour + "小时";
                }
                if (min > 0) {
                    time += parseFloat(min) + "分钟";
                }
                return time
            },
            $_goToDetails(row) {
                this.$router.push({
                    name: 'user-edit-workList',
                    params: {
                        id: row.id,
                        sort: 1
                    }
                });
            }
        },
        watch: {
            pager: {
                deep: true,
                handler: function () {
                    this.$_getTableList();
                },
            },
        }
    }
</script>

<style lang="less">
    .process-workList {
        width: 100%;

        .name {
            cursor: pointer;
            color: #1890FF;
            min-width: 200px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
</style>